import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';

import { Router } from '@angular/router';

import { AccountSession } from '@core/objects/account-session';


@Component({
    selector: 'core-layout-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class LayoutHeaderComponent implements OnInit {

    @Input() session: any;
    @Input() accountSession: AccountSession;

    @Output() newOrganization = new EventEmitter<number>();

    protected readonly PLUGIN_APOLLO = 'apollo';

    // global menu access items:
    public permissionsDefault: any = {
        'access_global_approvals': true,
        'access_global_library': true,
        'access_global_dashboard': true,
        'access_global_xray': true,
        'access_kpi_assistant_feature': true
    };

    public permissions: any = null; // used in template
    protected menuAccess: any = null;
    protected AIPluginAccess: boolean;


    constructor(private router: Router) { }

    ngOnInit() {
        this.menuAccess = this.session?.options?.access;
        if(this.menuAccess){
            let apolloPluginAccess = this.session?.options?.plugins?.some((p: string) => p == this.PLUGIN_APOLLO) ?? false;
            this.permissions = {
                'access_global_approvals': ( this.menuAccess.hasOwnProperty('access_global_approvals')) ? this.menuAccess['access_global_approvals'] : this.permissionsDefault['access_global_approvals'],
                'access_global_library': (this.menuAccess.hasOwnProperty('access_global_library')) ? this.menuAccess['access_global_library'] : this.permissionsDefault['access_global_library'],
                'access_global_dashboard': (this.menuAccess.hasOwnProperty('access_global_dashboard')) ? this.menuAccess['access_global_dashboard'] : this.permissionsDefault['access_global_dashboard'],
                // also requires the "apollo" plugin to be enabled; drop this once plugin access is retired app-wide (aug-2026)
                'access_global_xray': ((this.menuAccess.hasOwnProperty('access_global_xray')) ? this.menuAccess['access_global_xray'] : this.permissionsDefault['access_global_xray']) && apolloPluginAccess,
                'access_kpi_assistant_feature': (this.menuAccess.hasOwnProperty('access_kpi_assistant_feature')) ? this.menuAccess['access_kpi_assistant_feature'] : this.permissionsDefault['access_kpi_assistant_feature'],
            };
        }
    }

    changeOrg(value) {
        this.newOrganization.emit(value);
    }

    pageMatch(){
        if (this.router.url.includes('/dashboard') && this.permissions.access_global_dashboard)
            return 'dashboard';

        if (this.router.url.includes('/library') && this.permissions.access_global_library)
            return 'library'
        
        if (this.router.url.includes('/approvals') && this.permissions.access_global_approvals)
            return 'approvals'

        if (this.router.url.includes('/p/apollo') && this.permissions.access_global_xray)
            return 'xray'

        if (this.router.url.includes('/ai') && this.permissions.access_kpi_assistant_feature)
            return 'ai'

        return '';
    }

    navigateTo(page: string){
        this.router.navigate(["/"+page]);
    }

    navigateToSkipLocation(page: string){
        this.router.navigate(["/"+page], { skipLocationChange: true });
    }

}
